import AbstractComponent from './abstract-component.js';

const createFormTemplate = (className, isValidate) => {
  return (
    `<form class="${className}" action="" ${!isValidate ? `novalidate` : ``}>`
  );
};

export default class FormComponent extends AbstractComponent {
  constructor({className = ``, isValidate = true}) {
    super();

    this._className = className;
    this._isValidate = isValidate;
  }

  getTemplate() {
    return createFormTemplate(this._className, this._isValidate);
  }
}
